import React from "react";
import TalimTur from "../../components/AdminPanel/DarsJadval/TalimTur";

const AdminTalimTur = () => {
    return <div><TalimTur /></div>;
};

export default AdminTalimTur;
